
(function() {
  var GUARD_ID = 'minimum-order-guard';
  var WARNING_ID = 'minimum-order-warning';

  function getCartJson() {
    return fetch('/cart.js', {credentials: 'same-origin'}).then(function(r){return r.json();});
  }

  function centsFromCart(cart) {
    return typeof cart.total_price === 'number' ? cart.total_price : 0;
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'EUR' }).format((cents || 0) / 100);
    } catch(e) {
      return (cents/100).toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function findCheckoutButtons() {
    var selectors = [
      'form[action="/cart"] [name="checkout"]',
      'a[href^="/checkout"]',
      'button[name="checkout"]',
      '[data-checkout-button]'
    ];
    var nodes = [];
    selectors.forEach(function(s){ document.querySelectorAll(s).forEach(function(n){ if(nodes.indexOf(n) === -1) nodes.push(n); }); });
    return nodes;
  }

  // Express/Dynamic Checkout (PayPal, Shop Pay, Apple/Google Pay) helpers
  function findExpressContainers() {
    var selectors = [
      '.shopify-payment-button',
      '.additional-checkout-buttons',
      'form[action*="/wallets/"]'
    ];
    var nodes = [];
    selectors.forEach(function(s){ document.querySelectorAll(s).forEach(function(n){ if(nodes.indexOf(n) === -1) nodes.push(n); }); });
    return nodes;
  }

  function findExpressButtons() {
    var selectors = [
      '.shopify-payment-button button',
      '.shopify-payment-button [role="button"]',
      '.shopify-payment-button__button',
      '.additional-checkout-buttons button',
      '.additional-checkout-buttons a',
      'form[action*="/wallets/"] button',
      'form[action*="/wallets/"] [type="submit"]',
      'a[href*="/wallets/"]'
    ];
    var nodes = [];
    selectors.forEach(function(s){ document.querySelectorAll(s).forEach(function(n){ if(nodes.indexOf(n) === -1) nodes.push(n); }); });
    return nodes;
  }

  function overlayContainer(container, on) {
    if (!container) return;
    var key = 'data-min-order-overlay';
    if (on) {
      if (!container.getAttribute(key)) {
        var overlay = document.createElement('div');
        overlay.style.cssText = 'position:absolute; inset:0; z-index:9999; background:rgba(255,255,255,0);';
        overlay.setAttribute('data-role', 'min-order-overlay');
        // Ensure container is positioned
        var style = getComputedStyle(container);
        if (style.position === 'static') container.style.position = 'relative';
        container.appendChild(overlay);
        container.setAttribute(key, '1');
      }
    } else {
      var ex = container.querySelector('div[data-role="min-order-overlay"]');
      if (ex) ex.remove();
      container.removeAttribute(key);
    }
  }

  function setExpressDisabled(disabled) {
    // Disable/hide clickable express checkout elements and block interactions at container level
    var btns = findExpressButtons();
    btns.forEach(function(btn){
      try {
        if (disabled) {
          btn.setAttribute('aria-disabled', 'true');
          btn.setAttribute('disabled', 'disabled');
          btn.style.pointerEvents = 'none';
          btn.classList.add('is-disabled');
        } else {
          btn.removeAttribute('aria-disabled');
          btn.removeAttribute('disabled');
          btn.style.pointerEvents = '';
          btn.classList.remove('is-disabled');
        }
      } catch(e) {}
    });
    var containers = findExpressContainers();
    containers.forEach(function(c){
      if (disabled) {
        c.setAttribute('aria-disabled', 'true');
        c.style.pointerEvents = 'none';
        c.style.opacity = c.style.opacity || '0.7';
        overlayContainer(c, true);
      } else {
        c.removeAttribute('aria-disabled');
        c.style.pointerEvents = '';
        // only remove opacity if we set it
        if (c.style.opacity === '0.7') c.style.opacity = '';
        overlayContainer(c, false);
      }
    });
  }

  function preventExpressSubmit(e) {
    try {
      var target = e.target;
      if (!target || !target.action) return;
      if (target.action.indexOf('/wallets/') !== -1) {
        var guard = document.getElementById(GUARD_ID);
        if (!guard) return;
        var min = parseInt(guard.getAttribute('data-min-cents') || '1000', 10);
        // We need fresh cart totals
        e.preventDefault();
        e.stopImmediatePropagation();
        getCartJson().then(function(cart){
          var total = centsFromCart(cart);
          if (total >= min) {
            // Re-submit programmatically if allowed
            target.submit();
          } else {
            ensureWarning(total, min, cart.currency);
          }
        });
      }
    } catch(err) {}
  }

  function setButtonsDisabled(disabled) {
    var btns = findCheckoutButtons();
    btns.forEach(function(btn){
      if (disabled) {
        btn.setAttribute('aria-disabled', 'true');
        btn.setAttribute('disabled', 'disabled');
        btn.classList.add('is-disabled');
        btn.addEventListener('click', blockClick, { capture: true });
      } else {
        btn.removeAttribute('aria-disabled');
        btn.removeAttribute('disabled');
        btn.classList.remove('is-disabled');
        btn.removeEventListener('click', blockClick, { capture: true });
      }
    });
  }

  function blockClick(e) {
    // Verhindern, dass Checkout ausgelöst wird, wenn Mindestbetrag nicht erreicht ist
    var guard = document.getElementById(GUARD_ID);
    if (!guard) return;
    var min = parseInt(guard.getAttribute('data-min-cents') || '1000', 10);
    getCartJson().then(function(cart){
      var total = centsFromCart(cart);
      if (total < min) {
        e.preventDefault();
        e.stopImmediatePropagation();
        ensureWarning(total, min, cart.currency);
      }
    });
  }

  function ensureWarning(totalCents, minCents, currency) {
    var existing = document.getElementById(WARNING_ID);
    var container = document.getElementById(GUARD_ID);
    if (!container) return;
    var message = 'Achtung: Der Checkout ist erst ab einem Mindestbestelltwert von 10,00\u00A0€ verfügbar.';
    var current = 'Dein aktueller Warenkorbwert: ' + formatMoney(totalCents, currency);
    if (!existing) {
      var el = document.createElement('div');
      el.id = WARNING_ID;
      el.style.cssText = 'margin:1rem 0; padding:0.75rem 1rem; background:#f28888; color:#000000; border:1px solid #ffecb5; border-radius:6px;';
      el.innerHTML = message + '<br><small>' + current + '</small>';
      container.appendChild(el);
    } else {
      existing.innerHTML = message + '<br><small>' + current + '</small>';
    }
  }

  function applyGuard() {
    var guard = document.getElementById(GUARD_ID);
    if (!guard) return;
    var min = parseInt(guard.getAttribute('data-min-cents') || '1000', 10);
    var currency = guard.getAttribute('data-currency') || 'EUR';
    getCartJson().then(function(cart){
      var total = centsFromCart(cart);
      var shouldDisable = total < min;
      setButtonsDisabled(shouldDisable);
      setExpressDisabled(shouldDisable);
      if (shouldDisable) ensureWarning(total, min, currency);
      else {
        var existing = document.getElementById(WARNING_ID);
        if (existing) existing.remove();
      }
    });
  }

  

  // Beim Laden prüfen
  document.addEventListener('DOMContentLoaded', function(){
    document.addEventListener('submit', preventExpressSubmit, true);
    applyGuard();
  });

  // Bei Interaktionen/DOM-Änderungen erneut prüfen (z. B. Cart-Drawer, Mengenänderungen)
  var mo = new MutationObserver(function(){ applyGuard(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // Zusätzliche Sicherheit: regelmäßig prüfen (debounced)
  var ticking = false;
  window.addEventListener('cart:updated', function(){ if (!ticking) { ticking = true; requestAnimationFrame(function(){ ticking = false; applyGuard(); }); } });
})();
